import secureApi from '../../utils/secureApi';
import { Banner } from '../../pages/BannerManagement/types';

interface UpdateBannerParams {
  id: string;
  payload: Partial<Banner>;
}

export async function updateBanner({ id, payload }: UpdateBannerParams): Promise<Banner> {
  // Always include _id in the payload body, and remove 'id' if present
  const { id: _, ...rest } = payload;
  const fullPayload = { ...rest, _id: id };
  const response = await secureApi.post<any>(
    `/api/v1/tournaments/admin/banners/edit?_id=${id}`,
    fullPayload
  );
  
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  return (response as any)?.data || response;
} 